import { useEffect, useMemo, useRef, useState } from "react";
import TitlePage from "../../../../components/TitlePage";
import { Row, Col, Button, Form, InputGroup} from "react-bootstrap";
import { ConsultaTotvsEmpresaIndividual } from "../../../../../backend/ConsultaTotvsEmpresa";
import ResponsiveDataTable from "../../../../components/DataTable";
import LoadingSpinner from "../../../../components/LoadinSpinner";
import InputGeral from "../../../../components/InputGeral/Index";

import ListaAvaliacaoNF from "../../../../../lib/json/consultas/AvaliacaoNotaFiscalFornecedores.json"
import FichaAvaliacaoNF from "../../../../../lib/json/consultas/AvaliacaoNotaFiscalFornecedor.json"
import SelectEmpresa from "../../../../components/Select/Empresa";
import SelectCentroCusto from "../../../../components/Select/CentroCusto";
import { ErroMsg, SucessoMsg } from "../../../../contents/VariaveisGlobais";
import { useNavigate } from "react-router-dom";
import { format, startOfMonth, startOfYear } from "date-fns";
import { usePopUp } from "../../../../components/BootBox";
import { handleData, handleValorTotal } from "../../../../components/GridCell/Preco";
import SelectFornecedor from "../../../../components/Select/Fornecedor";
import ConsumoTOTVS_POST from "../../../../../backend/ConsumoTotvs";
import SelectFixo from "../../../../components/SelectFixo";
import { useSessionStorageState } from "../../../../../hooks/useSessionStorageState";
import ExportarExcel from "../../../../components/ExportarExcel";
import { handleFornecedorNFColumn, handleFilialNotaFiscal, handleUsuarioInclusao, handleStatusNF } from "../../../../components/GridCell/NotaFiscal";
import ConsultaTotvs from "../../../../../backend/ConsultaTotvs";
import AvaliacaoNotaFiscal from "../AvaliacaoNotaFiscal";

function ListaAvaliacaoNotaFiscal(){
    const { DisparaBootBox, FechaBootBox  } = usePopUp();
    // define a exibição do Loading
    var tabelasDefault  = ListaAvaliacaoNF.tabelas;
    
    const refAvaliacao = useRef();
    const navigate = useNavigate();
    const currentDate = new Date()
    const firstDayOfYearDate = startOfYear(currentDate);
    const firstDayOfMonthDate = startOfMonth(currentDate);
    
    const [carregar, setCarregar] = useState(false);
    const [data, setData]   = useState([]);
    const [empresa, setEmpresa] = useSessionStorageState("avaliacaoNotaEmpresa",{value: '', text: ''});
    const [documento, setDocumento] = useSessionStorageState("avaliacaoNotaDocumento",'');
    const [dateDe, setDateDe] = useSessionStorageState("avaliacaoNotaDateDe",format(firstDayOfYearDate, 'yyyy-MM-dd'));
    const [dateAte, setDateAte] = useSessionStorageState("avaliacaoNotaDateAte",format(currentDate, 'yyyy-MM-dd'));
    const [dateDeDigitacao, setDateDeDigitacao] = useSessionStorageState("avaliacaoNotaDateDigitacaoDe",format(firstDayOfMonthDate, 'yyyy-MM-dd'));
    const [dateAteDigitacao, setDateAteDigitacao] = useSessionStorageState("avaliacaoNotaDateDigitacaoAte",format(currentDate, 'yyyy-MM-dd'));
    const [campoFornecedor, setCampoFornecedor] = useSessionStorageState("avaliacaoNotaFornecedor",null);
    const [campoStatus, setCampoStatus] = useSessionStorageState("avaliacaoNotaCampoStatus",{value: "0", text: "Todos", filtroSQL: "( 1 = 1 )"});    
    
    const options = [
        {
            value: '0',
            text: "Todos",
            filtroSQL: "( 1 = 1 )"
        },
        {
            value: '1',
            text: "Rejeitado",
            filtroSQL: "( F1_STATUS = 'R' )"
        },
        {
            value: '2',
            text: "Em Aprovação",
            filtroSQL: "( F1_STATUS = 'B' AND F1_APROV = '" + window._env_?.REACT_APP_APROVA_NF + "' )"
        },
        {
            value: '5',
            text: "Bloqueado por Tolerância",
            filtroSQL: "( F1_STATUS = 'B' AND F1_APROV != '" + window._env_?.REACT_APP_APROVA_NF + "' )"
        },
        {
            value: '3',
            text: "Pré Nota",
            filtroSQL: "( F1_STATUS = '' AND D1_TES = '' )"
        },
        {
            value: '4',
            text: "Nota Fiscal Classificada",
            filtroSQL: "( F1_STATUS NOT IN ('R','B') AND D1_TES != '' )"
        },
        {
            value: '5',
            text: "Nota Fiscal Excluídas",
        },

    ]

    const excelColumns = [
        {
            Header: 'Filial',
            accessor: "F1_FILIAL",
        },
        {
            Header: 'Documento',
            accessor: "F1_DOC",
        },
        {
            Header: 'Serie',
            accessor: "F1_SERIE",
        },
        {
            Header: 'Fornecedor',
            accessor: "F1_FORNECE",            
        },
        {
            Header: 'Loja Fornecedor',
            accessor: "F1_LOJA",            
        },
        {
            Header: 'Nome Fornecedor',
            accessor: "A2_NOME",            
        },
        {
            Header: 'Emissão',
            accessor: 'F1_EMISSAO',
            Cell: handleData
        },
        {
            Header: 'Digitação',
            accessor: 'F1_DTDIGIT',
            Cell: handleData
        },
        {
            Header: 'Valor',
            accessor: 'TOTAL',
            Cell: handleValorTotal
        },
        {
            Header: 'Status',
            accessor: 'TIPO_DOC',
            Cell: handleStatusNF
        },
        {
            Header: 'Usuário Inclusão',
            accessor: 'USRINC',
            Cell: handleUsuarioInclusao
        },
        {
            Header: 'Nota',
            accessor: 'F1_XNOTA'
        }
    ];
    
    // Colunas do grid
    const columns = [
        {
            Header: 'Filial',
            accessor: "F1_FILIAL",
            Cell: (item) => handleFilialNotaFiscal(item, DisparaBootBox, FechaBootBox, navigate),
        },
        {
            Header: 'Fornecedor',
            accessor: "F1_FORNECE",
            Cell: handleFornecedorNFColumn
        },
        {
            Header: 'Emissão',
            accessor: 'F1_EMISSAO',
            Cell: handleData
        },
        {
            Header: 'Digitação',
            accessor: 'INCLUSAO',
            Cell: handleData
        },
        {
            Header: 'Valor',
            accessor: 'TOTAL',
            Cell: handleValorTotal
        },
        {
            Header: 'Status',
            accessor: 'TIPO_DOC',
            Cell: (item) => { 
                const { F1_APROV, F1_STATUS, F1_XNOTA } = item.row.original
                const aprovFiscal = window._env_?.REACT_APP_APROVA_NF

                return (
                    <>
                        {F1_STATUS === 'B' && F1_APROV !== aprovFiscal && 'Bloqueado por Tolerância'}
                        { ( (F1_STATUS === 'B' && F1_APROV === aprovFiscal) || F1_STATUS !== 'B' ) && item.value }
                        <p><strong>Nota Avaliação:</strong>{F1_XNOTA}</p>
                    </>
                )
            }
        },
    ];

    // WHERE/filtros da consulta do grid
    const retornaConsultaDefault = () => {
        let consultaDefault = ListaAvaliacaoNF.consulta;
        let consultaFiltro = ' ';
        
        consultaFiltro += "AND F1_FILIAL = FILIAL(SF1) ";

        if(documento) {
            consultaFiltro += "AND F1_DOC = '"+documento+"' ";
        }
        if(dateDe) {
            consultaFiltro += "AND F1_EMISSAO >= '"+dateDe.replaceAll('-','')+"' ";
        }
        if(dateAte) {
            consultaFiltro += "AND F1_EMISSAO <= '"+dateAte.replaceAll('-','')+"' ";
        }
        if(dateDeDigitacao) {
            consultaFiltro += "AND CASE WHEN SUBSTRING(F1_USERLGI,3,1) != ' '  THEN DATEADD(DAY, CAST( CONCAT((ASCII(SUBSTRING(F1_USERLGI,12,1)) - 50),ASCII(SUBSTRING(F1_USERLGI,16,1)) - 50) + IIF(SUBSTRING(F1_USERLGI,8,1) != '<', 1000, 1 ) AS INT), CASE WHEN SUBSTRING(F1_USERLGI,8,1) IN ('=','<') THEN '20230519' ELSE '19960101' END) ELSE NULL END >= '"+dateDeDigitacao.replaceAll('-','')+"' ";
        }
        if(dateAteDigitacao) {
            consultaFiltro += "AND CASE WHEN SUBSTRING(F1_USERLGI,3,1) != ' '  THEN DATEADD(DAY, CAST( CONCAT((ASCII(SUBSTRING(F1_USERLGI,12,1)) - 50),ASCII(SUBSTRING(F1_USERLGI,16,1)) - 50) + IIF(SUBSTRING(F1_USERLGI,8,1) != '<', 1000, 1 ) AS INT), CASE WHEN SUBSTRING(F1_USERLGI,8,1) IN ('=','<') THEN '20230519' ELSE '19960101' END) ELSE NULL END <= '"+dateAteDigitacao.replaceAll('-','')+"' ";
        }
        if(campoFornecedor?.value) {
            consultaFiltro += "AND F1_FORNECE + F1_LOJA = '"+campoFornecedor.value+"' ";
        }
        if(campoStatus?.value) {
            if (campoStatus.value == "5"){
                consultaDefault = consultaDefault.replace("D_E_L_E_T_ <> '*'", "D_E_L_E_T_ = '*'")
                consultaDefault = consultaDefault.replace("D_E_L_E_T_ != '*'", "D_E_L_E_T_ = '*'")
                consultaFiltro = "AND ( F1_STATUS = 'R' ) "
            }else{
                consultaFiltro += "AND "+campoStatus.filtroSQL+" ";
            }
        }
        
        return consultaDefault.replace('FILTRO', consultaFiltro)
    }

    // Processa consulta do grid
    const listaAvaliacaoNF = async () => {
        var consultaDefault = retornaConsultaDefault();
        let empresaFilial = empresa.value ? empresa.value.substr(0,window._env_?.REACT_APP_TAMANHO_EMPRESA) + '-' + empresa.value.substr(-window._env_?.REACT_APP_TAMANHO_FILIAL) : ''

        setCarregar(true);
        var retConsulta = await ConsultaTotvsEmpresaIndividual( consultaDefault, tabelasDefault, empresaFilial );
        setData(retConsulta.data);
        setCarregar(false);
    }

    useEffect( () => {
        listaAvaliacaoNF()
    },[])

    const handleVisualizar = async(row) =>{
        const {F1_FILIAL, F1_FORNECE, F1_LOJA, F1_DOC, F1_SERIE, A2_NOME } = row.original

        let cConsulta = FichaAvaliacaoNF.consulta
        let cFiltro = " AND F1_FILIAL = '" + F1_FILIAL + "' "
        cFiltro += " AND F1_DOC = '" + F1_DOC + "' "
        cFiltro += " AND F1_SERIE = '" + F1_SERIE + "' "
        cFiltro += " AND A2_COD = '" + F1_FORNECE + "' "
        cFiltro += " AND A2_LOJA = '" + F1_LOJA + "' "

        cConsulta = cConsulta.replace('FILTRO', cFiltro);

        const oPergunta = await ConsultaTotvs( cConsulta, FichaAvaliacaoNF.tabelas )
        
        if (oPergunta.data){
            const perguntasMock = oPergunta.data.map( (item) => { 
                const aPergunta = item.ZT9_DESCRI.split('||')
                const aResposta = JSON.parse(item.RESPOSTA)

                return {
                    CodigoPergunta: item.PTY_IDAVAL,
                    DescricaoPergunta: aPergunta[0],
                    Valor: aResposta[item.PTY_IDAVAL],
                    PesoPergunta: aPergunta[1],
                    Opcoes: item.OPCOES,
                    Desabilitar: true
                }
            })

            // Renderiza o componente diretamente no BootBox
            DisparaBootBox(
                `Avaliação Nota Fiscal: ${F1_SERIE + '/' + F1_DOC} - ${F1_FORNECE + '/' + F1_LOJA + ' - ' + A2_NOME.trim()}`,
                () => <AvaliacaoNotaFiscal ref={refAvaliacao} perguntas={perguntasMock} />,
                [
                    { variant: 'light', action: FechaBootBox, label: '↩ Voltar' }
                ],
                null,
                false,
                'xl',
                true,
                true // withComponent = true
            );
            
            //Verifica se deve "Avaliar" e realiza o Questionário 
            return false
        }
    }

    const handleDocumento = () => {
        const value = documento.trim() ? documento.trim().padStart(9, '0'): "";
        
        setDocumento(value);
    }

    const excelHeaders = useMemo(() => {
        return excelColumns.map(col => col.Header);
    }, [excelColumns]);

    const excelRows = useMemo(() => {
        return data.map(item =>
            excelColumns.map(col => {
                const value = item[col.accessor];

                if (col.Cell) {
                    return col.Cell({ value, row: { original: item } });
                }
                return value ?? ""; // valor padrão se undefined/null
            })
        );
    }, [data, excelColumns]);

    return (
        <>
            <Row>
                <LoadingSpinner isLoading={carregar}/>
                <Col md="12" xs="12">
                    <TitlePage text="Avaliação de Nota Fiscal" exibirIncluir={false}/>
                </Col>
                <Col md='3'>
                    <SelectEmpresa
                        campoEmpresa={empresa}
                        onChangeEmpresa={setEmpresa}
                    />
                </Col>
                <Col md="6" xs="12">
                    <SelectFornecedor
                        campoFornecedor={campoFornecedor}
                        changeFornecedor={setCampoFornecedor}
                        empresaLogada={empresa.value}
                    />
                </Col>
                <Col md="3" xs="12">
                    <SelectFixo 
                        options={options} 
                        value={campoStatus} 
                        selectedOptionValue={campoStatus}
                        isLabel={true} 
                        label="Status" 
                        onChange={(e) => setCampoStatus(e)}
                    />
                </Col>
            </Row>
            <Row>
                <Col md="2" xs="12">
                    <InputGeral 
                        label="Documento"
                        tipo='text'
                        max="9"
                        value={documento}  // Define o valor do campo com base no estado
                        handleBlur={handleDocumento}
                        onChange={(e) => setDocumento(e.target.value)}
                    />
                </Col>
                <Col md="2" xs="12">
                    <InputGeral
                        label="Emissão de"
                        tipo='date'
                        value={dateDe}
                        onChange={(e) => setDateDe(e.target.value)}
                    />
                </Col>
                <Col md="2" xs="12">
                    <InputGeral
                        label="Emissão até"
                        tipo='date'
                        value={dateAte}
                        onChange={(e) => setDateAte(e.target.value)}
                    />
                </Col>
                <Col md="2" xs="12">
                    <InputGeral
                        label="Digitação de"
                        tipo='date'
                        value={dateDeDigitacao}
                        onChange={(e) => setDateDeDigitacao(e.target.value)}
                    />
                </Col>
                <Col md="2" xs="12">
                    <InputGeral
                        label="Digitação até"
                        tipo='date'
                        value={dateAteDigitacao}
                        onChange={(e) => setDateAteDigitacao(e.target.value)}
                    />
                </Col>                
            </Row>
            <Row className="d-flex justify-content-end">
                <Col md="3" xs="12">
                    <Button 
                        variant="outline-primary" 
                        type="submit" 
                        onClick={listaAvaliacaoNF}
                        className="w-100"
                    >
                        Buscar
                    </Button>
                </Col>
                <Col md="3" xs="12">
                    <ExportarExcel 
                        nomeArquivo="Nota_Fiscal"
                        headers={excelHeaders}
                        rows={excelRows}
                    />
                </Col>
            </Row>
            
            <Row>
                <Col md="12" xs="12">
                    <ResponsiveDataTable 
                        columns={columns} 
                        data={data} 
                        buttons={[
                            {isVisual: true, action: handleVisualizar, label: "Visualizar", icone: "MdOutlinePreview", style: "light"}, 
                        ]}
                        paginacao={100}
                    />
                </Col>
            </Row>
        </>
    );
}

export default ListaAvaliacaoNotaFiscal;